import { render, staticRenderFns } from "./User-Panel.vue?vue&type=template&id=b8a5465a"
import script from "./User-Panel.vue?vue&type=script&lang=js"
export * from "./User-Panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports